import {Component} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  // fix-header

}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/app.component.ts